import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
const groupByDate = (data) => {
    return data.reduce((result, item) => {
        const dateKey = moment(item.created_at).format("DD/MM/YYYY");
        if (!result[dateKey]) {
            result[dateKey] = [];
        }
        result[dateKey].push(item);
        return result;
    }, {});
};

const IntrepreterAvailability = (props) => {
    const { interpreterUnAvailability, isLoading } = props;
    const groupedData = groupByDate(interpreterUnAvailability);
    const firstDate = interpreterUnAvailability?.length > 0 ? interpreterUnAvailability[0].created_at : new Date();
    const monthName = moment(firstDate).format('MMMM');
    return (
        <Box sx={{
            width: '100%',
            padding: '20px 0px 20px 0px'
        }}>
            {interpreterUnAvailability && interpreterUnAvailability?.length > 0 ? <Box sx={{
                width: '100%',
                height: '100%',
                background: "rgba(244, 244, 244, 1)",
                border: "1px solid rgba(8, 85, 127, 0.2)",
                borderRadius: '15px',
            }}>
                <Typography sx={{
                    width: '100%',
                    background: "rgba(0, 151, 178, 1)",
                    padding: '15px 20px',
                    color: 'white',
                    borderRadius: '14px 14px 0px 0px'
                }}>
                    {monthName}
                </Typography>
                {Object.keys(groupedData).map((date, index) => {
                    const slots = groupedData[date];
                    return (
                        <Box key={index} sx={{
                            width: '100%',
                            display: 'flex',
                            padding: '20px 0',
                            gridGap: '10px'
                        }}>
                            <Grid container spacing={2} alignItems={'center'}>
                                <Grid item xs={12} md={2}>
                                    <Typography sx={{
                                        padding: '10px 20px',
                                        color: 'rgba(0, 0, 0, 1)',
                                    }}>
                                        {date}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                    <Box sx={{
                                        background: "rgba(255, 255, 255, 1)",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        flexWrap: 'wrap',
                                        padding: '10px 10px',
                                        gridGap: '10px'
                                    }}>
                                        {slots?.map((slot, idx) => (
                                            <Typography key={idx} sx={{
                                                padding: '10px 20px',
                                                background: "rgba(0, 151, 178, 0.1)",
                                                color: 'rgba(0, 0, 0, 1)',
                                                borderRadius: '5px'
                                            }}>
                                                {moment(slot?.from_time).format("hh:mm A")} - {moment(slot?.to_time).format("hh:mm A")}
                                            </Typography>
                                        ))}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    );
                })}
            </Box> : <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                <NoDataImg />
            </Box>}
        </Box>

    );
};

export default IntrepreterAvailability;
